module.exports = __webpack_public_path__ + "assets/img/page_8.9fb023c2.png";